/* Hero slideshow — crossfade on a timer.
   The slide switcher is gone, so the only way through the slides is autoplay.
   It stands down under prefers-reduced-motion and pauses on hover, both of
   which matter more now that there is no control to stop it by hand. */
(function () {
  'use strict';

  function setup(hero) {
    if (hero.dataset.ready === 'true') return;
    hero.dataset.ready = 'true';

    var copies = hero.querySelectorAll('[data-hero-copy]');
    var layers = hero.querySelectorAll('[data-hero-layer]');
    if (layers.length < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;

    function show(next) {
      if (next === index) return;
      index = next;

      copies.forEach(function (copy, i) {
        copy.hidden = i !== index;
      });

      layers.forEach(function (layer, i) {
        layer.style.opacity = i === index ? '1' : '0';
        if (i === index) layer.removeAttribute('aria-hidden');
        else layer.setAttribute('aria-hidden', 'true');
      });
    }

    function play() {
      if (reduce || hero.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(function () {
        show((index + 1) % layers.length);
      }, parseInt(hero.dataset.interval, 10) || 7000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : play();
    });

    play();
  }

  function init() {
    document.querySelectorAll('[data-hero]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
